<div class="paypal-confirmation p-4">
  <h2 class="mb-4">{{ 'paypal_confirm_title' | translate }}</h2>

  <!-- Initializing -->
  @if (initializing()) {
    <div class="text-center py-5">
      <c-spinner color="primary"></c-spinner>
      <p class="mt-3">{{ 'paypal_initializing' | translate }}</p>
    </div>
  }

  <!-- Init error -->
  @if (!initializing() && errorMessage() && !paypalOrderId()) {
    <c-alert color="danger" class="mb-4">
      <h4 class="alert-heading">{{ 'paypal_error_title' | translate }}</h4>
      <p>{{ errorMessage() }}</p>
      <hr />
      <div class="d-flex gap-2">
        <button cButton color="danger" size="sm" (click)="retry()">
          {{ 'paypal_retry' | translate }}
        </button>
        <button cButton color="secondary" size="sm" (click)="goBack()">
          {{ 'paypal_back' | translate }}
        </button>
      </div>
    </c-alert>
  }

  <!-- Payment -->
  @if (!initializing() && paypalOrderId()) {
    <div class="payment-form">
      <!-- Order Summary -->
      <c-card class="mb-4 shadow-sm">
        <c-card-header>
          <strong>{{ 'paypal_order_summary' | translate }}</strong>
        </c-card-header>
        <c-card-body>
          <div class="d-flex justify-content-between mb-2">
            <span>{{ 'paypal_order_id' | translate }}</span>
            <strong>#{{ orderId }}</strong>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <span>{{ 'payment_subtotal' | translate }}</span>
            <span>{{ totalPrice | currencyAmount: currency }}</span>
          </div>
          @if (paymentCosts > 0) {
            <div class="d-flex justify-content-between mb-2 text-body-secondary">
              <span>{{ 'payment_processing_fee' | translate }}</span>
              <span>{{ paymentCosts | currencyAmount: currency }}</span>
            </div>
          }
          <hr class="my-2" />
          <div class="d-flex justify-content-between mb-3">
            <strong>{{ 'paypal_total_amount' | translate }}</strong>
            <strong class="text-primary fs-4">
              {{ totalWithCosts | currencyAmount: currency }}
            </strong>
          </div>
          <div class="d-flex justify-content-between text-body-secondary small">
            <span>{{ 'paypal_mode' | translate }}</span>
            <c-badge [color]="paypalMode() === 'live' ? 'success' : 'warning'">
              {{ paypalMode() === 'live' ? ('paypal_mode_live' | translate) : ('paypal_mode_test' | translate) }}
            </c-badge>
          </div>
        </c-card-body>
      </c-card>

      <!-- Error -->
      @if (errorMessage()) {
        <c-alert color="danger" class="mb-4">
          {{ errorMessage() }}
        </c-alert>
      }

      <!-- Processing overlay -->
      @if (processing()) {
        <div class="text-center py-3">
          <c-spinner size="sm" class="me-2"></c-spinner>
          {{ 'paypal_processing' | translate }}
        </div>
      }

      <!-- PayPal Smart Buttons -->
      <div id="paypal-button-container" class="mb-4" [class.d-none]="processing()"></div>

      <!-- Actions -->
      <div class="d-flex">
        <button
          cButton
          color="secondary"
          size="lg"
          (click)="goBack()"
          [disabled]="processing()"
        >
          <svg cIcon name="cilArrowLeft" class="me-2"></svg>
          {{ 'paypal_back' | translate }}
        </button>
      </div>

      <!-- Security Note -->
      <div class="text-center mt-4 text-body-secondary small">
        <svg cIcon name="cilLockLocked" class="me-1"></svg>
        {{ 'paypal_secured_by' | translate }}
      </div>
    </div>
  }
</div>
